export default __webpack_public_path__ + "static/media/web-green.44c13dbd.svg";